import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import { LandingCTAWrapper } from '@anm/components/video-landings/LandingCTA';
import { device } from '@anm/styles/helpers';
import { textColorVariants } from '@anm/styles/landingThemeStyles';
import styled, { css } from 'styled-components';
export var LogoWrapper = styled.div.withConfig({
  componentId: "aawly9-0"
})(["margin-bottom:26px;"]);
export var CTAWrapper = styled.div.withConfig({
  componentId: "aawly9-1"
})(["margin-bottom:32px;&:empty{display:none;}"]);
export var LandingTitle = styled(TitleBlock).withConfig({
  componentId: "aawly9-2"
})([""]);
export var LandingMetaWrapper = styled.div.withConfig({
  componentId: "aawly9-3"
})(["color:#292a2b;margin:0 auto;", " ", ""], function (_ref) {
  var colorTheme = _ref.colorTheme;
  return textColorVariants[colorTheme || 'pure'];
}, function (_ref2) {
  var fontStyles = _ref2.fontStyles;
  return fontStyles && css(["", "{h1:first-child{", ";font-size:36px;line-height:50px;margin:0 0 20px 0;text-align:center;}", "{", ";font-size:16px;line-height:28px;margin-bottom:26px;}}"], LandingTitle, fontStyles.headline, TitleDescription, fontStyles.body);
});
var rowDirectionBasicTemplate = css(["@media ", "{max-width:420px;margin-right:40px;text-align:left;}", "{& > div:not(:first-child){display:none;@media ", "{display:block;}}}"], device.laptop, LandingMetaWrapper, device.laptop);
var columnDirectionBasicTemplate = css(["", "{display:none;}"], LandingCTAWrapper);
var templateFourFiveWithoutMeta = css(["display:flex;align-items:center;justify-content:space-between;& > div{margin-right:0;}"]);
var templateFourFiveWithMeta = css(["@media ", "{& > div{display:flex;justify-content:space-between;}}"], device.laptop);
var layoutVariants = {
  basic: css(["", ";", "{max-width:600px;}"], function (_ref3) {
    var layoutDirection = _ref3.layoutDirection;
    return layoutDirection === 'row' ? rowDirectionBasicTemplate : columnDirectionBasicTemplate;
  }, LandingMetaWrapper),
  t1: css(["display:flex;align-items:center;flex-direction:column;", "{max-width:720px;}"], LandingMetaWrapper),
  t2: css(["text-align:left;@media ", "{max-width:400px;margin-right:40px;align-self:center;& + div{margin:0;}}@media ", "{max-width:500px;}"], device.laptop, device.desktop),
  t3: css(["margin-top:26px;text-align:left;@media ", "{margin-top:0;max-width:400px;margin-left:40px;align-self:center;}", "{display:none;@media ", "{display:block;}}@media ", "{max-width:500px;}"], device.laptop, LogoWrapper, device.laptop, device.desktop),
  t4: css(["text-align:left;", ";@media ", "{margin:0 auto;}.title_block{@media ", "{min-width:400px;max-width:720px;}& > *:not(h1){display:none;@media ", "{display:block;font-size:16px;line-height:28px;margin-bottom:26px;white-space:pre-wrap;}}}.cta_wrapper > div{margin-top:0;@media ", "{margin-left:40px;}}"], function (_ref4) {
    var isNoMeta = _ref4.isNoMeta;
    return isNoMeta ? css(["", ""], templateFourFiveWithoutMeta) : css(["", ""], templateFourFiveWithMeta);
  }, device.laptop, device.laptop, device.laptop, device.laptop),
  t5: css(["text-align:left;margin:48px auto 0;", ";.cta_wrapper > div{margin-top:0;@media ", "{margin-left:40px;}}@media ", "{.title_block{min-width:400px;max-width:720px;}}"], function (_ref5) {
    var isNoMeta = _ref5.isNoMeta;
    return isNoMeta ? css(["", ""], templateFourFiveWithoutMeta) : css(["@media ", "{", "}"], device.laptop, templateFourFiveWithMeta);
  }, device.laptop, device.laptop)
};
export var Wrapper = styled.div.withConfig({
  componentId: "aawly9-4"
})(["", " ", ""], function (_ref6) {
  var maxWidth = _ref6.maxWidth;
  return maxWidth && css(["max-width:", "px;"], maxWidth);
}, function (_ref7) {
  var layoutVariant = _ref7.layoutVariant;
  return layoutVariants[layoutVariant || 'basic'];
});